import { LoadingSpinner } from '@aibees/elephant/components/loading-spinner';
import { PersonEmailInfo } from '@aibees/elephant/components/person-email-info';
import { classnames } from '@aibees/shared/utils';
import { Divider, Stack, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PeopleEmailPopoverProps as Props } from './types';
import { getEmailsCleared } from './utils';
import { Icon } from '@aibees/shared/components';

export const PeopleEmailPopover = memo(({ className, item }: Props) => {
  const emails = useMemo(() => {
    return getEmailsCleared(item?.revelation?.email);
  }, [item?.revelation?.email]);

  if (!item || !emails) {
    return (
      <Styled.Wrapper
        className={classnames('PeopleEmailPopover', className)}
        sx={SX.root}
      >
        <Stack alignItems="center" height="120px">
          <LoadingSpinner textIncluded />
        </Stack>
      </Styled.Wrapper>
    );
  }

  return (
    <Styled.Wrapper
      className={classnames('PeopleEmailPopover', className)}
      sx={SX.root}
    >
      <Stack direction="row" alignItems="center" gap={0.5} p={1}>
        <Icon name="address-book" size={18} color="primary.500" />
        <Typography variant="body3" fontWeight={700} color="grey.700">
          Contact Details
        </Typography>
      </Stack>
      <Divider />
      <Stack p={1}>
        <PersonEmailInfo emails={emails} data={item} />
      </Stack>
    </Styled.Wrapper>
  );
});

PeopleEmailPopover.displayName = 'PeopleEmailPopover';
